/*
  Added-to-cart panel and quick add for "Completează echipamentul".
  - Venture's AjaxCart dispatches "ams:cart:added" (cancelable) with the line
    item; when #AmsAdded exists we cancel it, fill the panel and open it.
  - [data-ams-kit-add] buttons add a single-variant product (data-qty units:
    a whole box for cartridges priced per piece).
  - Nothing starts ticked: an extra product goes in the cart only when the
    customer ticks it (EU 2011/83 art. 22, no pre-ticked extra payments).
  - [data-ams-bundle] adds the product on the page plus the ticked
    suggestions ([data-ams-kit-check]) in one click; the main "Adaugă în coș"
    (and the phone buy bar) does the same while something is ticked.
  - [data-ams-recs] fills a suggestion list from Shopify recommendations
    (complementary, then related) for products without kit rules.
  - [data-ams-buybar] keeps price and add to cart at the bottom on phones.
  - [data-ams-photo-count] follows the swiped photo on phones, and the strip
    scrolls to the chosen variant's photo.
*/
(function () {
  'use strict';

  function tr(key, fallback) { var s = window.amsStrings && window.amsStrings[key]; return s || fallback; }

  var panel = document.getElementById('AmsAdded');
  var lastFocus = null;

  function money(cents) {
    if (window.amsMoney) return window.amsMoney(cents);
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function updateHeaderCount(count) {
    var link = document.querySelector('.site-header__cart');
    if (!link) return;
    var badge = link.querySelector('.ams-cart-count');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'ams-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    if (badge) badge.textContent = count;
    var hidden = link.querySelector('.ams-visually-hidden');
    if (hidden) hidden.textContent = tr('upsell.header_count', ', {count} produse').replace('{count}', count);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Count cart lines, not units: a box of 50 cartridges is one product.
        var lines = (cart.items || []).length;
        updateHeaderCount(lines);
        if (panel) {
          var total = panel.querySelector('[data-ams-added-total]');
          var count = panel.querySelector('[data-ams-added-count]');
          if (total) total.textContent = money(cart.total_price);
          if (count) count.textContent = (lines === 1 ? tr('upsell.count_one', '({count} produs)') : tr('upsell.count_other', '({count} produse)')).replace('{count}', lines);
        }
        return cart;
      })
      .catch(function () {});
  }

  function fillItem(item, others) {
    if (!panel || !item) return;
    var extra = panel.querySelector('[data-ams-added-extra]');
    if (extra) {
      var names = (others || []).map(function (x) {
        var n = (x.product_title || x.title || '').replace(/^XX\s+/i, '');
        return x.quantity > 1 ? n + ' (' + tr('upsell.pieces', '{count} buc.').replace('{count}', x.quantity) + ')' : n;
      });
      extra.hidden = !names.length;
      extra.textContent = names.length ? '+ ' + names.join(', ') : '';
    }
    var img = panel.querySelector('[data-ams-added-img]');
    var name = panel.querySelector('[data-ams-added-name]');
    var variant = panel.querySelector('[data-ams-added-variant]');
    var price = panel.querySelector('[data-ams-added-price]');
    if (img) {
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2');
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }
    if (name) name.textContent = (item.product_title || item.title || '').replace(/^XX\s+/i, '');
    var vt = item.variant_title;
    if (variant) {
      variant.hidden = !vt || vt === 'Default Title';
      variant.textContent = vt || '';
    }
    if (price) price.textContent = item.quantity + ' × ' + money(item.final_price || item.price);
  }

  // ---------- Fallback suggestions: Shopify recommendations ----------
  function loadRecs(box) {
    if (box.getAttribute('data-loaded')) return;
    box.setAttribute('data-loaded', '1');
    var productId = box.getAttribute('data-product-id');
    var limit = Number(box.getAttribute('data-limit')) || 4;
    var exclude = ',' + (box.getAttribute('data-exclude') || '') + productId + ',';
    // Related products of the same type are alternatives, not add-ons.
    var ownType = (box.getAttribute('data-type') || '').trim().toLowerCase();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function get(intent) {
      var url = root + 'recommendations/products?product_id=' + productId +
        '&limit=10&intent=' + intent + '&section_id=ams-kit-recommendations';
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          return Array.prototype.slice.call(holder.querySelectorAll('.ams-kit__item')).filter(function (row) {
            if (exclude.indexOf(',' + row.getAttribute('data-product-id') + ',') !== -1) return false;
            var type = (row.getAttribute('data-type') || '').trim().toLowerCase();
            return !(intent === 'related' && ownType && type === ownType);
          }).slice(0, limit);
        })
        .catch(function () { return []; });
    }

    get('complementary')
      .then(function (rows) { return rows.length ? rows : get('related'); })
      .then(function (rows) {
        if (!rows.length) return;
        var list = box.querySelector('.ams-kit__list');
        rows.forEach(function (row) { list.appendChild(row); });
        box.hidden = false;
      });
  }

  document.querySelectorAll('[data-ams-recs]:not([data-lazy])').forEach(loadRecs);

  function open() {
    if (!panel || panel.classList.contains('is-open')) return;
    var lazyRecs = panel.querySelector('[data-ams-recs][data-lazy]');
    if (lazyRecs) loadRecs(lazyRecs);
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ams-added-lock');
    var dialog = panel.querySelector('.ams-added__panel');
    if (dialog) setTimeout(function () { dialog.focus(); }, 50);
  }

  function close() {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ams-added-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (panel) {
    document.addEventListener('ams:cart:added', function (evt) {
      evt.preventDefault();
      fillItem(evt.detail);
      refreshCart();
      open();
    });

    panel.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-ams-added-close]')) close();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') close();
    });
  }

  // ---------- Package: this product + the ticked suggestions ----------
  var bundle = document.querySelector('[data-ams-bundle]');
  var kitBlock = bundle ? bundle.closest('.ams-kit') : null;

  function bundleChecks() {
    return kitBlock ? Array.prototype.slice.call(kitBlock.querySelectorAll('[data-ams-kit-check]')) : [];
  }


  function currentVariant() {
    var json = document.getElementById(bundle.getAttribute('data-product-json'));
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!json || !form) return null;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return null; }
    var select = form.querySelector('[name="id"]');
    var variantId = select ? Number(select.value) : 0;
    var variant = null;
    (product.variants || []).forEach(function (v) { if (v.id === variantId) variant = v; });
    return variant;
  }

  function bundleParts() {
    if (!bundle) return null;
    var variant = currentVariant();
    if (!variant || !variant.available) return null;
    var form = document.querySelector('form[action*="/cart/add"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    var extras = [];
    bundleChecks().forEach(function (box) {
      if (!box.checked || box.disabled) return;
      extras.push({
        id: Number(box.getAttribute('data-variant-id')),
        quantity: Number(box.getAttribute('data-qty')) || 1,
        price: Number(box.getAttribute('data-price')) || 0
      });
    });
    if (!extras.length) return null;
    var total = variant.price * qty;
    extras.forEach(function (x) { total += x.price; });
    return { main: { id: variant.id, quantity: qty }, extras: extras, total: total };
  }

  function renderBundle() {
    if (!bundle) return;
    // Sold-out product: no package, each suggestion keeps its own "Adaugă" button.
    var variant = currentVariant();
    kitBlock.classList.toggle('ams-kit--pick', !!(variant && variant.available));
    var parts = bundleParts();
    if (window.amsSyncBuybar) window.amsSyncBuybar();
    syncAtcExtras(parts);
    if (!parts) { bundle.hidden = true; return; }
    var n = parts.extras.length;
    bundle.querySelector('[data-ams-bundle-count]').textContent =
      n === 1 ? tr('upsell.bundle_count_one', 'Produsul + 1 produs ales') : tr('upsell.bundle_count_other', 'Produsul + {count} produse alese').replace('{count}', n);
    bundle.querySelector('[data-ams-bundle-total]').textContent = money(parts.total);
    bundle.querySelector('[data-ams-bundle-add]').textContent =
      n === 1 ? tr('upsell.bundle_add_one', 'Adaugă produsul și produsul ales') : tr('upsell.bundle_add_other', 'Adaugă produsul și cele {count} produse').replace('{count}', n);
    bundle.hidden = false;
  }

  // The main "Adaugă în coș" also adds the ticked suggestions, which sit lower on the page.
  // Say so right under the button, with the total and a link to change the choice.
  var atcExtras = document.querySelector('[data-ams-atc-extras]');
  function syncAtcExtras(parts) {
    if (!atcExtras) return;
    if (!parts) { atcExtras.hidden = true; atcExtras.textContent = ''; return; }
    var n = parts.extras.length;
    var extra = 0;
    parts.extras.forEach(function (x) { extra += x.price; });
    atcExtras.textContent = '';
    atcExtras.appendChild(document.createTextNode(
      (n === 1 ? tr('upsell.atc_extras_one', 'Se adaugă și 1 produs bifat mai jos ({extra}). Total: {total}. ')
               : tr('upsell.atc_extras_other', 'Se adaugă și {count} produse bifate mai jos ({extra}). Total: {total}. '))
        .replace('{count}', n).replace('{extra}', money(extra)).replace('{total}', money(parts.total))));
    var link = document.createElement('a');
    link.href = '#' + (kitBlock.id || '');
    link.textContent = tr('upsell.atc_extras_change', 'Modifică');
    atcExtras.appendChild(link);
    atcExtras.hidden = false;
  }

  if (bundle) {
    renderBundle();
    document.addEventListener('change', function (evt) {
      if (evt.target.closest('form[action*="/cart/add"]')) setTimeout(renderBundle, 50);
      if (evt.target.matches('[data-ams-kit-check]')) renderBundle();
    });
    // A tap anywhere on a row (outside its links) ticks it.
    kitBlock.addEventListener('click', function (evt) {
      if (evt.target.closest('a, input, label, button')) return;
      var row = evt.target.closest('.ams-kit__item');
      var box = row && row.querySelector('[data-ams-kit-check]');
      if (!box || box.disabled || !kitBlock.classList.contains('ams-kit--pick')) return;
      box.checked = !box.checked;
      renderBundle();
    });
    bundle.querySelector('[data-ams-bundle-add]').addEventListener('click', function () {
      var parts = bundleParts();
      if (!parts) return;
      var button = this;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = '…';
      var items = [parts.main].concat(parts.extras.map(function (x) { return { id: x.id, quantity: x.quantity }; }));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          parts.extras.forEach(function (x) { markAdded(String(x.id)); });
          button.disabled = false;
          renderBundle();
          if (bundle.hidden) button.textContent = label;
          var added = data && data.items ? data.items : [];
          fillItem(added[0], added.slice(1));
          refreshCart();
          open();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = label;
          // Fall back to the regular add to cart for the main product.
          var submit = document.querySelector('form[action*="/cart/add"] [type="submit"]');
          bundleFallback = true;
          if (submit) submit.click();
          bundleFallback = false;
        });
    });
  }

  // The main "Adaugă în coș" adds the ticked suggestions too, so a customer who
  // ticked cartridges and a safe gets them without finding the second button.
  // Runs in the capture phase, before Venture's AjaxCart submit handler.
  var bundleFallback = false;
  if (bundle) {
    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (bundleFallback || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form !== document.querySelector('form[action*="/cart/add"]') || !bundleParts()) return;
      evt.preventDefault();
      evt.stopPropagation();
      bundle.querySelector('[data-ams-bundle-add]').click();
    }, true);
  }

  // Every copy of a suggestion (product page list and panel list) shows it is in the cart.
  function markAdded(id) {
    document.querySelectorAll('[data-ams-kit-add][data-variant-id="' + id + '"]').forEach(function (b) {
      b.disabled = true;
      b.classList.add('is-added');
      b.textContent = tr('upsell.added', 'Adăugat');
    });
    document.querySelectorAll('[data-ams-kit-check][data-variant-id="' + id + '"]').forEach(function (box) {
      box.checked = true;
      box.disabled = true;
      box.closest('.ams-kit__item').classList.add('is-added');
    });
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-ams-kit-add]');
    if (!button || button.disabled) return;
    var id = button.getAttribute('data-variant-id');
    var qty = Number(button.getAttribute('data-qty')) || 1;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        markAdded(id);
        // On the cart page the new line has to appear in the list.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        var item = data && data.items ? data.items[0] : null;
        if (typeof renderBundle === 'function') renderBundle();
        if (panel && !panel.classList.contains('is-open')) fillItem(item);
        refreshCart();
        open();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
        window.location.href = button.closest('.ams-kit__item').querySelector('.ams-kit__title').href;
      });
  });

  // ---------- Phones: sticky buy bar ----------
  var buybar = document.querySelector('[data-ams-buybar]');
  var realSubmit = buybar ? document.getElementById(buybar.getAttribute('data-submit')) : null;
  if (buybar && realSubmit && 'IntersectionObserver' in window) {
    var priceSource = document.getElementById(buybar.getAttribute('data-price-source'));
    var barPrice = buybar.querySelector('[data-ams-buybar-price]');
    var phone = window.matchMedia('(max-width: 749px)');
    var submitVisible = true;
    var barNote = barPrice ? barPrice.querySelector('small') : null;
    var syncBar = function () {
      var show = phone.matches && !submitVisible && !realSubmit.disabled;
      // With ticked suggestions the bar shows the package total, since its button adds them too.
      var parts = bundleParts();
      if (barPrice && barPrice.firstChild) {
        barPrice.firstChild.textContent = parts ? money(parts.total) : (priceSource ? priceSource.textContent.trim() : barPrice.firstChild.textContent);
      }
      if (barNote) barNote.hidden = !!parts;
      buybar.classList.toggle('ams-buybar--bundle', !!parts);
      var barAdd = buybar.querySelector('[data-ams-buybar-add]');
      if (barAdd) {
        if (!barAdd.getAttribute('data-label')) barAdd.setAttribute('data-label', barAdd.textContent);
        barAdd.textContent = parts ? tr('upsell.add_bundle', 'Adaugă pachetul') : barAdd.getAttribute('data-label');
      }
      buybar.hidden = !show;
    };
    window.amsSyncBuybar = syncBar;
    // A variant change updates the price and can disable the real button (sold out).
    var watch = new MutationObserver(syncBar);
    watch.observe(realSubmit, { attributes: true, attributeFilter: ['disabled'] });
    if (priceSource) watch.observe(priceSource, { childList: true, characterData: true, subtree: true });
    // The bar stays until the whole button is on screen: a button peeking 10 px
    // above the bottom edge is not something to tap.
    new IntersectionObserver(function (entries) {
      submitVisible = entries[0].intersectionRatio > 0.95;
      syncBar();
    }, { threshold: [0, 0.95, 1] }).observe(realSubmit);
    if (phone.addEventListener) phone.addEventListener('change', syncBar);
    buybar.querySelector('[data-ams-buybar-add]').addEventListener('click', function () {
      realSubmit.click();
    });
  }

  // ---------- Phones: photo count while swiping ----------
  var photoCount = document.querySelector('[data-ams-photo-count]');
  if (photoCount) {
    var strip = photoCount.parentNode.querySelector('.photos__item--main');
    var index = photoCount.querySelector('[data-ams-photo-index]');
    if (strip && index) {
      strip.addEventListener('scroll', function () {
        var n = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)) + 1;
        index.textContent = n;
      }, { passive: true });

      // The theme marks the chosen variant's photo by removing .hide; on phones
      // every photo is shown in the strip, so scroll to that one instead.
      var showCurrent = function (smooth) {
        if (strip.scrollWidth <= strip.clientWidth) return;
        var current = strip.querySelector('.product-single__photo:not(.hide)');
        if (!current) return;
        var left = current.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
        if (Math.abs(left - strip.scrollLeft) < 2) return;
        if (smooth && strip.scrollTo) strip.scrollTo({ left: left, behavior: 'smooth' });
        else strip.scrollLeft = left;
      };
      showCurrent(false);
      // Only a photo gaining or losing .hide counts; lazysizes also changes img classes.
      new MutationObserver(function (records) {
        var changed = records.some(function (r) {
          return r.target.parentNode === strip &&
            /(^|\s)hide(\s|$)/.test(r.oldValue || '') !== r.target.classList.contains('hide');
        });
        if (changed) showCurrent(true);
      }).observe(strip, { subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
  }
})();
